import { ca } from '@cian/analytics';

type TLabel = 'tab_realtor_sale' | 'tab_realtor_rent' | 'tab_realtor_other' | 'tab_realtor_sale_to_buy';

export const trackOpenPopup = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'main_page',
    action: 'Show_popup',
    label: 'Tab/realtor',
  });
};

export const trackPopupItemClick = (label: TLabel) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'main_page',
    action: 'Click_popup',
    label,
  });
};
